<script>
import appConfig from '@src/app.config.json'
import Axios from '@plugin/axios'
import Layout from '@layouts/main.vue'
import PlainCard from '@components/ui/cards/plain-card.vue'
import pdf from '@components/ui/pdf-viewer.vue'
import moment from 'moment'
import Skeleton from '@components/_base-skeleton.vue'
import queryString from 'query-string'

export default {
  page() {
    return {
      title: this.pageTitle,
      meta: this.pageMeta,
    }
  },
  components: {
    Layout,
    PlainCard,
    pdf,
    Skeleton,
  },
  filters: {
    fileName: function(string) {
      if (string !== null || string !== '#!') {
        return string
          .split('.')
          .pop()
          .toUpperCase()
      }
      return string
    },
    extension: function(string) {
      if (string === null || string === '#!') {
        return string
      }
      return string.split('/').pop()
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
    lastObj: function(obj, key = null) {
      if (!key) {
        return obj[obj.length - 1]
      } else {
        return obj[obj.length - 1][key]
      }
    },
    uppercase: function(string) {
      var splitStr = string.toLowerCase().split(' ')
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        if (
          splitStr[i] !== 'of' &&
          splitStr[i] !== 'the' &&
          splitStr[i] !== 'and'
        ) {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
        }
      }
      // Directly return the joined string
      return splitStr.join(' ')
    },
  },
  data() {
    return {
      article: {
        atribut: {
          lampiran: {
            data: {},
          },
          lembaga_pengadilan: {
            data: {},
          },
          member: {
            data: {},
          },
          nama_hakim: {
            data: {},
          },
          nama_para_pihak: {
            data: {},
          },
          nomor_putusan: {
            data: {},
          },
          status: {
            data: {},
          },
          tanggal_dibacakan: {
            data: {},
          },
          tanggal_ditetapkan: {
            data: {},
          },
        },
        taksonomi: {},
      },
      routes: this.$route.params,
      isLoading: true,
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      /** for SEO, meta and hero */
      currentUrl: window.location.origin + window.location.pathname,
      pageTitle: 'Loading...',
      pageDescription: '',
      pageMeta: [],
      datFile: '',
      notFoundState: false,
      pageName: 'data-center-single',
      documentS3:
        'https://lexikan-development.s3-ap-southeast-1.amazonaws.com/',
    }
  },
  watch: {
    article: {
      handler(val) {
        this.article.atribut = val.atribut
      },
      deep: true,
    },
  },
  mounted() {
    const url = this.$route
    const watchLang = queryString.parse(window.location.search).lang
    window.addEventListener('popstate', (e) => {
      history.pushState(
        { page: url.query.page },
        'page',
        `?page=${url.query.page}&data-center=${url.query['data-center']}`
      )
    })
    if (watchLang) {
      this.getDataCenter({ lang_relation: watchLang })
    } else {
      this.getDataCenter()
    }
  },
  methods: {
    getDataCenter(param = {}) {
      /**
       * Extract routes data from url
       */
      /** define ANY API prequisite */
      var params = {
        klaster_slug: this.routes.klaster_slug,
        record_slug: this.routes.slug.replaceAll('_', '/'),
        simple: true,
        // lang: this.lang,
      }
      // console.log(param)
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      /**
       * Do API Request
       */
      Axios.get(endpoint).then((response) => {
        const data = response.data.data[0]
        // console.log(data)
        if (response.data && data) {
          this.article = data
          this.openComment()
          this.isLoading = false
        } else {
          this.isLoading = false
          this.notFoundState = true
        }
        if (this.extension(data.atribut.lampiran.data[0].content) === 'dat') {
          this.readHtml(data.atribut.lampiran.data[0].content).then((resp) => {
            this.datFile = resp
          })
        }
        /** FOR SEO AND META TAG PURPOSE */
        this.pageTitle = data.title

        this.pageMeta = [
          {
            name: 'description',
            content: this.$options.filters
              .plainText(data.content)
              .slice(0, 160),
          },
          // facebook
          {
            property: 'og:type',
            content: 'article',
          },
          {
            property: 'og:title',
            content: data.title,
          },
          {
            property: 'og:description',
            content: this.$options.filters
              .plainText(data.content)
              .slice(0, 160),
          },
          {
            property: 'og:image',
          },
          {
            property: 'og:url',
            content: this.currentUrl,
          },
          {
            property: 'og:site_name',
            content: appConfig.title,
          },
          // twitter
          {
            name: 'twitter:title',
            content: data.title,
          },
          {
            name: 'twitter:image',
          },
          {
            name: 'twitter:description',
            content: this.$options.filters
              .plainText(data.content)
              .slice(0, 160),
          },
          {
            name: 'twitter:site',
            content: this.currentUrl,
          },
        ]
      })
    },
    /**
     * Open Comment, this should be in Mixin!
     */
    openComment: function() {
      // momento js
      const momento = document.createElement('script')
      momento.setAttribute('src', 'https://commento.lexikan.id/js/commento.js')
      document.head.appendChild(momento)
    },
    extension: function(string) {
      if (string === null || string === '#!') {
        return string
      }
      return string
        .split('/')
        .pop()
        .split('.')
        .pop()
    },
    readHtml(url) {
      return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest()
        xhr.open('get', 'https://cors-anywhere.herokuapp.com/' + url, true)
        xhr.onload = function() {
          var status = xhr.status
          if (status === 200) {
            resolve(xhr.response)
          } else {
            reject(status)
          }
        }
        xhr.send()
      })
    },
    download: function(ID) {
      return appConfig.download_handler + ID
    },
    formatDate: function(date) {
      if (this.lang === 'en') {
        require('moment/locale/en-gb')
      } else {
        require('moment/locale/id')
      }
      return moment(date).format('LL')
    },
  },
}
</script>

<template>
  <div>
    <b-container
      v-if="notFoundState"
      style="min-height: 50vh;display:flex;align-items:center"
    >
      <b-row :class="$style.errorHandler">
        <b-col cols="12">
          <p>
            {{ $t('data_center_no_data') }}
          </p>
          <a
            class="text-primary"
            pointer
            @click="$router.push({ name: 'data-center' })"
            >{{ $t('back_page') }}</a
          >
        </b-col>
      </b-row>
    </b-container>
    <Skeleton
      v-if="isLoading === true && notFoundState === false"
      :type="pageName === 'default' ? 'default' : pageName"
    ></Skeleton>
    <Layout v-else-if="isLoading === false && notFoundState === false">
      <b-container :class="$style.dataCenterContainer">
        <b-row>
          <b-col cols="12">
            <!-- Breadcrumb -->
            <ol class="breadcrumb mb-3 px-0">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item"
                ><router-link :to="'../'">{{
                  $route.params.klaster_slug.replace(/-/gi, ' ') | uppercase
                }}</router-link></li
              >
              <li class="breadcrumb-item">{{
                $route.params.slug.replace(/-/gi, ' ') | uppercase
              }}</li>
            </ol>
          </b-col>
          <b-col cols="lg-8">
            <article v-if="article.atribut" :class="$style.article">
              <div :class="$style.articleHeader">
                <h1>{{ article.title }}</h1>
                <ul :class="$style.headerInfo">
                  <div
                    v-if="routes.klaster_slug !== 'laws-and-regulations'"
                    :style="{ display: 'contents' }"
                  >
                    <li v-if="article.atribut.nama_para_pihak"
                      >Para Pihak:
                      <span
                        v-for="(pihak, index) in article.atribut.nama_para_pihak
                          .data"
                        :key="index"
                      >
                        {{ pihak.content }}
                      </span>
                    </li>
                    <li v-if="article.atribut.lembaga_pengadilan"
                      >Lembaga Pengadilan:
                      <span
                        v-for="(lp, index) in article.atribut.lembaga_pengadilan
                          .data"
                        :key="index"
                      >
                        {{ lp.content }}
                      </span>
                    </li>
                    <li v-if="article.atribut.nama_hakim"
                      >Nama Hakim:
                      <span
                        v-for="(hakim, index) in article.atribut.nama_hakim
                          .data"
                        :key="index"
                      >
                        <div v-html-safe="hakim.content"></div>
                      </span>
                    </li>
                  </div>

                  <div :style="{ display: 'contents' }">
                    <li
                      v-if="routes.klaster_slug === 'laws-and-regulations'"
                      cols="2"
                    >
                      <span v-if="article.atribut.tanggal_ditetapkan">
                        <img
                          src="@assets/icons/Icon_Tanggal.png"
                          alt="icon tanggal"
                          icon
                        />
                        <p
                          >Ditetapkan:
                          <span
                            v-for="(tanggal, index) in article.atribut
                              .tanggal_ditetapkan.data"
                            :key="index"
                          >
                            {{ formatDate(tanggal.content) }}
                          </span>
                        </p>
                      </span>
                      <span v-if="article.atribut.tanggal_ditetapkan">
                        <img
                          src="@assets/icons/Icon_Tanggal.png"
                          alt="icon tanggal"
                          icon
                        />
                        <p
                          >Berlaku:
                          <span
                            v-for="(tanggal, index) in article.atribut
                              .tanggal_berlaku.data"
                            :key="index"
                          >
                            {{ formatDate(tanggal.content) }}
                          </span>
                        </p>
                      </span>
                      <span v-if="article.atribut.status">
                        <img src="@assets/icons/Icon_Status.png" alt="" icon />
                        <p
                          >Status:
                          <span
                            v-for="(status, index) in article.atribut.status
                              .data"
                            :key="index"
                          >
                            {{ status.content }}
                          </span>
                        </p></span
                      >
                    </li>
                  </div>
                </ul>
              </div>
              <!-- content -->
              <div v-if="article.content">
                {{ article.content }}
              </div>
              <!-- end content -->
              <div
                v-if="article.atribut.lampiran"
                :class="$style.articleContent"
              >
                <div
                  v-for="(pdf, index) in article.atribut.lampiran.data"
                  :key="index"
                  :class="$style.eachContent"
                >
                  <pdf
                    v-if="extension(pdf.content).toLowerCase() === 'pdf'"
                    :src="
                      `https://cors-anywhere.herokuapp.com/${
                        routes.klaster_slug === 'international-conventions'
                          ? documentS3
                          : ''
                      }${pdf.content}`
                    "
                  >
                  </pdf>
                  <div v-else :class="$style.notSuportedDocs">
                    <!-- eslint-disable -->
                    {{
                      $t('Attachment') +
                        ' ' +
                        (index + 1) +
                        ': ' +
                        $t(
                          'This document does not yet have a file in PDF format. Please download available document'
                        )
                    }}
                    <!-- eslint-enable -->
                  </div>
                </div>
              </div>
            </article>
            <section id="comment" class="mt-5">
              <h2 :style="{ color: 'gray' }">{{ $t('Comments') }}</h2>
              <div id="commento"></div>
            </section>
          </b-col>
          <b-col cols="lg-4">
            <PlainCard v-if="article.atribut.lampiran" title="Lampiran">
              <div
                v-for="(pdf, index) in article.atribut.lampiran.data"
                :key="index"
                class="mx-2"
              >
                <p class="mb-0">Download {{ pdf.content | fileName }}</p>
                <a
                  :href="download(pdf.ID)"
                  pointer
                  :style="{ fontWeight: 600 }"
                  type="application/octet-stream"
                  :download="download(pdf.ID) | fileName"
                  target="_blank"
                  >{{ $t('Attachment') + ' ' + (index + 1) }}</a
                >
              </div>
              <small
                v-if="article.atribut.download_counts.data.length !== 0"
                class="mx-2"
                >{{ $t('Downloads') }}:
                {{ article.atribut.download_counts.data[0].content }}
              </small>
            </PlainCard>
          </b-col>
        </b-row>
      </b-container>
    </Layout>
  </div>
</template>

<style lang="scss" scoped module>
@import '@design';
.dataCenterContainer {
  margin-top: 4rem;
  margin-bottom: 4rem;
  .article {
    [icon] {
      width: 20px;
      height: 20px;
      margin-right: 0.5rem;
    }
    .articleHeader {
      h1 {
        font-weight: $bold;
        color: $dark;
      }
      .headerInfo {
        padding-left: 0;
        li {
          margin: 1rem 0;
          font-size: 1em;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.5);
          list-style: none;
          &[cols='2'] {
            span {
              display: inline-flex;
              align-items: center;
              margin-right: 1rem;
              p {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
    .articleContent {
      margin: 1rem 0;
      .eachContent {
        margin: 1rem 0;
      }
      .notSuportedDocs {
        margin-top: 3rem;
      }
    }
  }
}

@media only screen and (max-width: $mobile-sm) {
  .dataCenterContainer {
    .article {
      .articleHeader {
        h1 {
          font-size: 1.75em;
        }
        .headerInfo {
          padding-left: 0;
          li {
            font-size: 1em;
          }
        }
      }
    }
  }
}
</style>
